<template>
  <div>
    <popup
      ref="popup"
      heading="Default tier template"
      button-text="Default tier template"
      button-style="primary"
      :plain="true"
      button-size="small"
      button-icon="fa fa-sliders"
      :disable-button="!isManager('finance|management|admin')"
      :before-save="onBeforeSave"
      @save="onSave"
      @close="onClose">
      <default-tier-template-drawer ref="drawer" />
    </popup>
  </div>
</template>

<script>
import SiteMixins from '@/mixins/SiteMixins'
import Popup from '@/components/atoms/Popup'
import DefaultTierTemplateDrawer from './DefaultTierTemplateDrawer'

export default {
  name: 'default-tier-template-button',

  mixins: [SiteMixins],

  components: {
    Popup,
    DefaultTierTemplateDrawer
  },

  mounted () {
    // Watch the Popup child's showModal flag so we can trigger a fresh fetch
    // each time the drawer opens. Popup doesn't emit @open, so we watch the
    // internal data property. This is the standard pattern for components that
    // wrap Popup but need to react to open in this codebase.
    var self = this
    var popup = this.$refs.popup
    if (popup) {
      self.$watch(function () { return popup.showModal }, function (val) {
        if (val && self.$refs.drawer) {
          self.$refs.drawer.load()
        }
      })
    }
  },

  methods: {
    // beforeSave: Popup will only close and emit @save when this returns true.
    // The DISABLE_SAVE_EVENT bus should already block reaching this point when
    // invalid — this is a belt-and-suspenders guard.
    onBeforeSave () {
      if (!this.$refs.drawer) return false
      var tiersEditor = this.$refs.drawer.$refs.tiersEditor
      return !!(tiersEditor && tiersEditor.validate())
    },

    // Popup emits @save after closing the drawer.
    // Fire the async PUT here; send() / drawer.save() will toast on error.
    onSave () {
      if (this.$refs.drawer) {
        this.$refs.drawer.save().catch(function () {
          // send() already toasted; fallback is inside drawer.save()
        })
      }
    },

    onClose () {
      // No-op.
    }
  }
}
</script>
